

import { useEffect, useState } from "react";
import { AccessControlAPI, AccessSystemsAPI } from "../../api/accessControl";

export default function AccessControlDoorsPage() {
  const [systems, setSystems] = useState([]);
  const [doors, setDoors] = useState([]);
  const [systemId, setSystemId] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadSystems() {
    const data = await AccessSystemsAPI.list();
    const enabledSystems = Array.isArray(data)
      ? data.filter((system) => system.enabled)
      : [];

    setSystems(enabledSystems);
  }

  async function loadDoors() {
    try {
      setLoading(true);
      setError("");

      const data = await AccessControlAPI.listDoors({
        systemId: systemId || null,
        schoolId: schoolId || null,
      });

      setDoors(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to load access control doors", err);
      setError("Failed to load access control doors");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadSystems().catch((err) => {
      console.error("Failed to load access systems", err);
      setError("Failed to load access systems");
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    loadDoors();
  }, [systemId, schoolId]);

  function handleSystemChange(value) {
    const selected = systems.find((system) => String(system.id) === value);

    setSystemId(value);
    setSchoolId(selected ? selected.school_id : "");
  }

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Net2 Door Status</h1>
        <p className="text-sm text-gray-600">
          View synced door statuses from each access control system.
        </p>
      </div>

      {error && (
        <div className="rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="rounded border bg-white p-4">
        <label className="block text-sm font-medium mb-1">System</label>
        <select
          value={systemId}
          onChange={(e) => handleSystemChange(e.target.value)}
          className="w-full max-w-xl rounded border p-2"
        >
          <option value="">All systems</option>
          {systems.map((system) => (
            <option key={system.id} value={system.id}>
              {system.school_name} — {system.system_name}
            </option>
          ))}
        </select>
      </div>

      <div className="rounded border bg-white">
        <div className="flex items-center justify-between border-b p-3">
          <h2 className="font-medium">Doors</h2>
          <button
            type="button"
            onClick={loadDoors}
            className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700"
          >
            Refresh
          </button>
        </div>

        {loading ? (
          <div className="p-4 text-sm text-gray-600">Loading...</div>
        ) : doors.length === 0 ? (
          <div className="p-4 text-sm text-gray-600">No doors found.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="border-b bg-gray-50">
                <tr>
                  <th className="p-3">Door</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">School</th>
                  <th className="p-3">System ID</th>
                  <th className="p-3">Net2 Door ID</th>
                  <th className="p-3">Last Synced</th>
                </tr>
              </thead>
              <tbody>
                {doors.map((door) => (
                  <tr key={door.id} className="border-b align-top">
                    <td className="p-3 font-medium">{door.name || "Unknown door"}</td>
                    <td className="p-3">{door.status || "-"}</td>
                    <td className="p-3">{door.school_id || "-"}</td>
                    <td className="p-3">{door.system_id || "-"}</td>
                    <td className="p-3">{door.net2_door_id || "-"}</td>
                    <td className="p-3">
                      {door.last_synced_at
                        ? new Date(door.last_synced_at).toLocaleString()
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}